import sipHttpService from '../_services/sipHttpService'
import { GET_SIPCONFIG } from './mutation-types'

export default {
  buscarSipConfig: async ({ commit }) => {
    try {
      const response = await sipHttpService.getSipConfig()
      commit(GET_SIPCONFIG, response.data)
    } catch (error) {
      console.log(error)
    }
  },
}
